import { ReactElement } from 'react';

import { RecordContextProvider } from 'react-admin';
import { FunctionField } from 'shared/react-admin/Fields';
import { AdjustmentStatusChipField } from 'shared/react-admin/Fields/AdjustmentStatusChipField/AdjustmentStatusChipField';
import { OrderAdjustments } from 'types/embedded/orderAdjustments';

type Props = {
  label?: string | ReactElement | boolean;
};

export const OrderAdjustmentsReportStatusField: React.FC<Props> = ({ label }) => {
  return (
    <FunctionField
      label={label}
      render={(record: OrderAdjustments) => (
        <RecordContextProvider value={record.adjustmentStatus}>
          <AdjustmentStatusChipField source="description" />
        </RecordContextProvider>
      )}
    />
  );
};
